// Pitanja i odgovori za pocetnu stranicu: isti tekst se prikazuje na stranici (FaqCard.vue)
// i ide u FAQPage JSON-LD (pages/index.vue). Tekst menjaj samo ovde.
export const pocetnaFaq = [
  {
    question: 'Mogu li da postavim oglas besplatno?',
    answer: 'Da. Oglas možete besplatno da postavite kao fizičko lice ili da registrujete tezgu i objavljujete oglase na jednom mestu. Za objavu je potreban nalog, koji se pravi za nekoliko koraka.',
  },
  {
    question: 'Koliko dugo je oglas aktivan?',
    answer: 'Oglas je aktivan 30 dana od dana objavljivanja.',
  },
  {
    question: 'Šta je tezga i kako da je registrujem?',
    answer: 'Tezga je profil proizvođača ili firme na kome su svi vaši oglasi na jednom mestu. Registracija tezge je besplatna, a kako se kreira objašnjeno je na stranici „Kako kreirati tezgu".',
  },
  {
    question: 'Mogu li da vidim kako su se cene menjale kroz godine?',
    answer: 'Da. Za svaki proizvod postoji istorija cena po mesecima, a pregled po godinama dostupan je od 2018. godine, pa možete da pratite sezonska kretanja cena voća, povrća, žitarica i stoke.',
  },
  {
    question: 'Kako da pratim nove oglase i vesti?',
    answer: 'Oglas možete da zapratite srcem pored oglasa, a u browseru možete da uključite obaveštenja da bi vam stizale vesti, događaji i poruke za vaše oglase.',
  },
]
